<div class="legend-container">
  <div class="ranges pb-3">
    @let subnationalMapColorRanges = scoreColorService.subnationalMapColorRanges();

    @for (range of scoreColorService.colorRanges(); track range.minScore) {
      <div class="range">
        <span class="text-center key colour-coded" [style.background]="range.color" [style.color]="range.textColor">
          {{ range.minScore | score }}-{{ range.maxScore | score }}
        </span>
        <span>{{ range.riskLevel | translate }}</span>
        <div class="gradient-bar" [style.background]="subnationalMapColorRanges[$index].gradient"></div>
      </div>
    }
  </div>

  <div class="row no-gutters">
    <div class="col-12 pt-0">
      {{ indexExplanation() }}
    </div>
  </div>

  @if (!lite()) {
    <div class="row no-gutters">
      <div class="col-3">
        <grid-ui-icon class="subnational-icon" name="subnational-circle"></grid-ui-icon>
        <span>Subnational</span>
      </div>
    </div>
  }
</div>

@if (!lite()) {
  <div class="legend-footer-container">
    <div class="row no-gutters">
      <div class="col-3">
        <span><b>Verisk Maplecroft's Language of Probability:</b></span>
      </div>

      <div class="col-2">
        <span><b>Expected: </b>75% to &lt; 100%</span>
      </div>

      <div class="col-2">
        <span><b>Likely: </b>&gt; 50% to &lt; 75%</span>
      </div>

      <div class="col-2">
        <span><b>Unlikely: </b>25% to &lt; 50%</span>
      </div>

      <div class="col-2">
        <span><b>Remote: </b>&gt; 0% to &lt; 25%</span>
      </div>

      <div class="col-1"></div>
    </div>
  </div>
}
